import { useEffect, useRef, useState } from "react";
import { trans } from "utils/helpers";
import { getDynamicDataGridApi } from "../api";
import { SimpleGrid } from "./SimpleGrid/SimpleGrid";

interface DynamicDataGridPropsType {
  valueString?: string,

  resetForm?: boolean,
  required?: boolean,
  returnObj?: boolean,
  mode?: string,
  DynamicObj?: any,
  name: string,
  onChange?: (e) => void,
  dataGridDataCallBack: (e) => void,
  handleRowsData?: (e:any) => void,
  tbodyLength?:number
  resizeOption?:boolean
  dataEntry?:boolean
}

export const DynamicDataGrid = ({dataGridDataCallBack,dataEntry=false,handleRowsData,resizeOption,tbodyLength=3 ,mode,DynamicObj , valueString ,returnObj=false ,resetForm,required , name="" ,onChange}: DynamicDataGridPropsType) => {

  const [response, setResponse] = useState<any>();
  const [DataGridFieldsTest,setDataGridFieldsTest]=useState<any>()

  async function getDynamicDataGridAsync() {

      const res = await getDynamicDataGridApi(DynamicObj.KeyId );
      setResponse(res)
      if(JSON.parse(res?.DataGridFields)?.inputList){
setDataGridFieldsTest(JSON.parse(res?.DataGridFields)?.inputList)
      }else{
        setDataGridFieldsTest(JSON.parse(res?.DataGridFields))

      }
  


      dataGridDataCallBack(res)
   
  }


  useEffect(() => {

    if(!DynamicObj.DataGridObject){
 
      
      getDynamicDataGridAsync()
    }else{


      setResponse(DynamicObj)
    
    if(JSON.parse(DynamicObj?.DataGridFields)?.inputList){
setDataGridFieldsTest(JSON.parse(DynamicObj?.DataGridFields).inputList)
      }else{
        setDataGridFieldsTest(JSON.parse(DynamicObj?.DataGridFields))

      }


    }
  }, [resetForm ,DynamicObj]);




  return (
    <>
    
    {response&&
      <>
      {DynamicObj?.label ?
      <div className="card legendCard my-3">
        <div className="legend">
         {DynamicObj?.label }
       </div>
      <SimpleGrid dataEntry={dataEntry} mode={mode} DynamicObj={response} resizeOption={resizeOption} handleRowsData={handleRowsData}  
      theadData={
        //اگر جدول از صفحه جداول ساخته شده باشد شامل اینپوت لیست یا همون کارد هست و باید فلت مپ بزنیم تا دیتاها جمع بشن ولی اگر جدول توی خود فرم ساز از تب مجموعه داده ساخته باشه دیگه اینپوت لیست نداره و وارد قسمت در غیر اینصورت میشه
       
      //  JSON.parse(response?.DataGridFields)?.inputList ||
        DataGridFieldsTest?.[0]?.inputList? DataGridFieldsTest.flatMap(item=>item?.inputList):
        DataGridFieldsTest|| []} tbodyData={DynamicObj?.defaultValue} theadLength={DataGridFieldsTest?.length} tbodyLength={tbodyLength}/>
      </div>
    
        :

      <SimpleGrid dataEntry={dataEntry} mode={mode} DynamicObj={response} resizeOption={resizeOption} handleRowsData={handleRowsData}  theadData={JSON.parse(response?.DataGridFields)?.inputList || []} tbodyData={DynamicObj?.defaultValue} theadLength={JSON.parse(response?.DataGridFields)?.inputList.length} tbodyLength={tbodyLength}/>
    }
      </>
    }
     
    </>
  )
}